import { withStyles } from "@material-ui/core";
import {
  getVoidUnassignGroupedHelperMessage,
  getVoidUnassignMessage,
} from "./utils";

const styles = () => ({
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
});
const ConfirmationDialogContent = ({ classes, isGroupedPickups, isBulkVoidPickup }) => {
  const groupedHelperMessage = getVoidUnassignGroupedHelperMessage({
    isGroupedPickups,
    isBulkVoidPickup,
  });

  return (
    <div className={classes.confirmDialogContent}>
      <span>
        {getVoidUnassignMessage(isBulkVoidPickup)}
        <br />
        {groupedHelperMessage}
      </span>
    </div>
  );
};

export default withStyles(styles)(ConfirmationDialogContent);
